import { useSelector } from 'react-redux';

import { Box, Typography } from '@material-ui/core';

import Button from '../../../Button/Button.component';

import { useSetDefaultCard } from 'hooks/payments.hook';

const SetDefaultCardForm = () => {
  const { id } = useSelector(state => state.payments.target);

  const { mutate, isLoading } = useSetDefaultCard();

  const onClickHandler = event => {
    event.preventDefault();
    mutate(id);
  };

  return (
    <>
      <Typography>
        ¿Confirmas que deseas que esta tarjeta sea tu forma de pago principal?
      </Typography>
      <Box pt={2} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          loading={isLoading}
          onClick={onClickHandler}
        >
          Confirmar
        </Button>
      </Box>
    </>
  );
};

export default SetDefaultCardForm;
